import React, { useState, useMemo, useEffect } from 'react';
import ShowMoreText from 'react-show-more-text';
import './style.scss';
import { API } from '../../../API/index';

import { ShareList } from "../../ShareList";
import { MAX_LENGTH_STORY } from "../../../utils/constants";

export const History = ({ history, full=false }) => {
    //console.log('history', history);
    const [like, setLike] = useState(history.liked);
    const [toggleShow, setToggleShow] = useState(full);
    const [disabledBtn, setDisabledBtn] = useState(false);

    /*    useEffect(() => {
        const objLikes = getStorageItem('lk', {});
        const isLike = Boolean(objLikes[history.id]);

        setLike(isLike);
    }, []);*/
    
    const executeOnClick = (isExpanded) => {
        setToggleShow(isExpanded);
    };

    const toggleLike = () => {
        setDisabledBtn(true);
        //const objLikes = getStorageItem('lk', {});

        if (like) {
            //dislikeAxios(history.id, objLikes);
            dislikeAxios(history.id, {});
        } else {
            //likeAxios(history.id, objLikes);
            likeAxios(history.id, {});
        }

    };

    const likeAxios = (_id, _storage) => {
        API.like_story(history.id, { appealId: _id })
            .then((res) => {
                if (!_storage[_id]) {
                    _storage[_id] = true;
                }
                //console.log('likeAxios', res);
                //window.localStorage.setItem('lk', JSON.stringify(_storage));
                setLike(true);
            })
            .catch((err) => {
                console.log('err like', err);
            }).finally(() => {
                setDisabledBtn(false);
            });
    };

    const dislikeAxios = (_id, _storage) => {
        API.dislike_story(history.id, { appealId: _id })
            .then((res) => {
                if (_storage[_id]) {
                    delete _storage[_id];
                }
                //console.log('dislikeAxios', res);
                //window.localStorage.setItem('lk', JSON.stringify(_storage));
                setLike(false);
            })
            .catch((err) => {
                console.log('err dislike', err);
            }).finally(() => {
                setDisabledBtn(false);
            });
    };

    /*    const showMore = (event) => {
        event.preventDefault();
        if (full) {
            return null;
        }
        setToggleShow((prev) => !prev);
    };*/

    const renderBodyText = useMemo(() => {
        //console.log('history.body', history.body);
        if (!history.body) {
            return null;
        }
        const arrSplit = history.body.split("\n");

        return arrSplit.map((item, index) => {
            const _item=item.trim();

            if (_item) {
                return <p key = { index }>{_item}<br /><br /></p>;
            }
        });
        //return history.body.replace(/\\n/gi, '<br/><br/>');
    }, [history]);

    const renderShowMore = useMemo(() => {
        return (
            <div className = { `history__toggle ${toggleShow ? 'history__toggle--active' : ''}` }>
                <span className = 'history__toggle-text'>
                    {toggleShow ? 'Згорнути' : 'Дочитати'}
                    <i className = 'icon icon-arrow-bottom history__toggle-icon' />
                </span>
            </div>
        );
    }, [toggleShow]);

    const renderBody = useMemo(() => {
        if (!history.body) {
            return null;
        }
        if (!full && history.body.length > MAX_LENGTH_STORY) {
            return (
                <button className = { `history__description-wrap ` }>
                    <div className = { `history__description ${toggleShow ? 'history__description--active' : ''}` }>
                        {/*<p dangerouslySetInnerHTML = { { __html: renderBody } } />*/}
                        <ShowMoreText

                            /* Default options */
                            anchorClass = ''
                            expanded = { false }
                            less = { renderShowMore }
                            lines = { 7 }
                            more = { renderShowMore }
                            onClick = { executeOnClick }>
                            {renderBodyText}
                        </ShowMoreText>
                    </div>
                </button>
            );
        }

        return (
            <div className = 'history__description-wrap'>
                <div className = 'history__description history__description--active'>
                    {renderBodyText}
                </div>
            </div>
        );

    }, [toggleShow, full, history]);

    const renderCategory = useMemo(() => {

        if (!Array.isArray(history.categories)) {
            return history.categories;
        }

        const sortCat = [...history.categories].sort();

        return sortCat.map((cat) => {
            return (
                <div className = 'history__category-wrap' key = { cat }>
                    <span className = 'history__category'>{ cat }</span>
                </div>
            );
        });
    }, [history.categories]);

    return (
        <article className = 'history' id = { history.id }>
            <div className = 'history__categories'>
                {renderCategory}
            </div>

            <h2 className = 'history__title'>{ history.title }</h2>

            {renderBody}

            <div className = 'history__events'>
                <div>
                    <div className = 'history__share'>
                        <span className = 'history__share-text'>
                            Поділитися:
                        </span>
                        <ShareList customUrl = { `/history/${history.id}` } />
                    </div>
                </div>
                <button
                    className = { `history__like ${like ? 'history__like--active' : ''}` }
                    disabled = { disabledBtn }
                    onClick = { toggleLike }>
                    <i className = 'icon icon-sympathize history__like-icon' />
                    <span className = 'history__like-text'>Підтримати</span>
                </button>
            </div>

        </article>
    );
};
